export enum NatureBergeDroite {
    Inconnue = 0,
    Naturelle = 1,
    Enrochement = 2,
    Artificielle = 3
}
